<template>
  <div class="container_self">
    <el-row class="table_parent">
      <el-row class="search_parent">
        <el-row style="margin-bottom: 15px">
          <el-button type="danger" size="mini" icon="el-icon-plus" @click="handleCreate"
            >创建任务</el-button
          >
          <el-button type="warning" size="mini" icon="el-icon-copy-document" @click="handleCopyTask"
            >复制任务</el-button
          >
        </el-row>
        <el-form :model="searchForm" :inline="true" size="mini">
          <el-form-item label="任务名称">
            <el-input
              v-model="searchForm.name"
              clearable
              placeholder="请输入任务名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="任务类型">
            <el-input
              v-model="searchForm.taskType"
              clearable
              placeholder="请输入任务类型"
            ></el-input>
          </el-form-item>
          <el-form-item label="包名">
            <el-input
              v-model="searchForm.packageName"
              clearable
              placeholder="请输入包名"
            ></el-input>
          </el-form-item>
          <el-form-item label="语言">
            <el-input
              v-model="searchForm.lang"
              clearable
              placeholder="请输入语言"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.enabled" clearable placeholder="请选择状态">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否正式">
            <el-select v-model="searchForm.formal" clearable placeholder="请选择">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" icon="el-icon-search" @click="search"
              >搜索</el-button
            >
          </el-form-item>
        </el-form>
      </el-row>

      <h3>任务列表</h3>
      <el-table
        :data="tableData"
        v-loading="loading"
        element-loading-text="加载中，请稍后"
        style="width: 100%"
      >
        <el-table-column align="center" prop="id" label="ID" width="55">
        </el-table-column>
        <el-table-column align="center" prop="name" label="任务名称" min-width="120" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="promptWords" label="任务提示词" width="130" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="taskUniqueId" label="唯一标识" width="110" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="taskType" label="任务类型" width="130" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="packageName" label="App包名" width="160" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" prop="lang" label="语言" width="65">
        </el-table-column>
        <el-table-column align="center" label="是否启用" width="75">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled === 1 ? 'success' : 'danger'" size="mini">
              {{ scope.row.enabled === 1 ? '已启用' : '未启用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="周期" width="75">
          <template slot-scope="scope">
            <span>{{ cycleMap[scope.row.cycle] || scope.row.cycle }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="sorted" label="排序" width="55">
        </el-table-column>
        <el-table-column align="center" label="奖励" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.rewardAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="ecpm" label="ECPM" width="70">
        </el-table-column>
        <el-table-column align="center" prop="stayTime" label="最低停留(秒)" width="100">
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建时间" width="155">
        </el-table-column>
        <el-table-column label="操作" align="center" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-row>

    <!-- 创建任务弹窗 -->
    <el-dialog title="创建任务" :visible.sync="createDialogVisible" width="750px">
      <el-form :model="createForm" size="mini" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务名称">
              <el-input v-model="createForm.name" placeholder="任务名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务类型">
              <el-input v-model="createForm.taskType" placeholder="任务类型"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="App包名">
              <el-input v-model="createForm.packageName" placeholder="App包名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="语言">
              <el-select v-model="createForm.lang" style="width:100%;" placeholder="请选择语言">
                <el-option label="global" value="global"></el-option>
                <el-option label="zh" value="zh"></el-option>
                <el-option label="en" value="en"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务提示词">
              <el-input v-model="createForm.promptWords" placeholder="任务提示词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图标">
              <el-input v-model="createForm.icon" placeholder="图标"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="按钮提示词">
              <el-input v-model="createForm.actionText" placeholder="按钮提示词"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="广告标识">
              <el-input v-model="createForm.adTag" placeholder="广告标识"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="奖励数量">
              <el-input-number v-model="createForm.rewardAmount" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每日最大奖励数">
              <el-input-number v-model="createForm.dayRewardMax" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="周期">
              <el-select v-model="createForm.cycle" style="width:100%;">
                <el-option label="一次性(0)" :value="0"></el-option>
                <el-option label="每日(1)" :value="1"></el-option>
                <el-option label="每周(2)" :value="2"></el-option>
                <el-option label="每月(3)" :value="3"></el-option>
                <el-option label="无限次(9)" :value="9"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="限制次数">
              <el-input-number v-model="createForm.limitNum" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number v-model="createForm.sorted" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收益率ECPM">
              <el-input-number v-model="createForm.ecpm" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最低停留(秒)">
              <el-input-number v-model="createForm.stayTime" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源">
              <el-input v-model="createForm.source" placeholder="来源"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="是否启用">
              <el-select v-model="createForm.enabled" style="width:100%;">
                <el-option label="未启用" :value="0"></el-option>
                <el-option label="已启用" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="正式环境">
              <el-select v-model="createForm.formal" style="width:100%;">
                <el-option label="测试" :value="false"></el-option>
                <el-option label="正式" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="任务描述">
          <el-input
            type="textarea"
            :rows="2"
            v-model="createForm.description"
            placeholder="任务描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="扩展配置(JSON)">
          <el-input
            type="textarea"
            :rows="4"
            v-model="createForm.extra"
            placeholder='扩展配置，JSON格式，如：{"uniqueName":"xxx","url":"http://"}'
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createDialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sureCreateTask" size="mini">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 复制任务弹窗 -->
    <el-dialog title="复制任务" :visible.sync="copyDialogVisible" width="500px" @close="handleCancelCopy">
      <el-alert
        title="目标包名/域名下的任务必须为空才可使用此功能"
        type="warning"
        :closable="false"
        show-icon
        style="margin-bottom: 15px;"
      >
      </el-alert>
      <el-form :model="copyForm" size="mini" label-width="130px">
        <el-form-item label="任务来源包名" required>
          <el-input v-model="copyForm.fromPackageName" placeholder="任务来源包名"></el-input>
        </el-form-item>
        <el-form-item label="语言">
          <el-select v-model="copyForm.lang" style="width:100%;" placeholder="语言：zh, en, es">
            <el-option label="zh" value="zh"></el-option>
            <el-option label="en" value="en"></el-option>
            <el-option label="es" value="es"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务类型">
          <el-input v-model="copyForm.taskType" placeholder="任务类型，可为空"></el-input>
        </el-form-item>
        <el-form-item label="目标包名" required>
          <el-input v-model="copyForm.toPackageName" placeholder="目标包名"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelCopy" size="mini">取 消</el-button>
        <el-button type="primary" @click="sureCopyTask" size="mini">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 编辑任务弹窗 -->
    <el-dialog title="编辑任务" :visible.sync="editDialogVisible" width="750px">
      <el-form :model="editForm" size="mini" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务名称">
              <el-input v-model="editForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="任务类型">
              <el-input v-model="editForm.taskType"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="App包名">
              <el-input v-model="editForm.packageName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="语言">
              <el-select v-model="editForm.lang" style="width:100%;">
                <el-option label="global" value="global"></el-option>
                <el-option label="zh" value="zh"></el-option>
                <el-option label="en" value="en"></el-option>
                <el-option label="pt" value="pt"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务提示词">
              <el-input v-model="editForm.promptWords"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="图标">
              <el-input v-model="editForm.icon"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="按钮提示词">
              <el-input v-model="editForm.actionText"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="广告标识">
              <el-input v-model="editForm.adTag"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="奖励数量">
              <el-input-number v-model="editForm.rewardAmount" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每日最大奖励数">
              <el-input-number v-model="editForm.dayRewardMax" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="周期">
              <el-select v-model="editForm.cycle" style="width:100%;">
                <el-option label="一次性(0)" :value="0"></el-option>
                <el-option label="每日(1)" :value="1"></el-option>
                <el-option label="每周(2)" :value="2"></el-option>
                <el-option label="每月(3)" :value="3"></el-option>
                <el-option label="无限次(9)" :value="9"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="限制次数">
              <el-input-number v-model="editForm.limitNum" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number v-model="editForm.sorted" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收益率ECPM">
              <el-input-number v-model="editForm.ecpm" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="最低停留(秒)">
              <el-input-number v-model="editForm.stayTime" :min="0" style="width:100%;"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="来源">
              <el-input v-model="editForm.source"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="是否启用">
              <el-select v-model="editForm.enabled" style="width:100%;">
                <el-option label="未启用" :value="0"></el-option>
                <el-option label="已启用" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="正式环境">
              <el-select v-model="editForm.formal" style="width:100%;">
                <el-option label="测试" :value="false"></el-option>
                <el-option label="正式" :value="true"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="任务描述">
          <el-input
            type="textarea"
            :rows="2"
            v-model="editForm.description"
          ></el-input>
        </el-form-item>
        <el-form-item label="扩展配置(JSON)">
          <el-input
            type="textarea"
            :rows="4"
            v-model="editForm.extra"
            placeholder='扩展配置，JSON格式'
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="sureEditTask" size="mini">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { axiosGet, axiosPost } from "@/assets/ajaxFn.js";
export default {
  data() {
    return {
      total: 0,
      loading: false,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      cycleMap: {
        0: "一次性",
        1: "每日",
        2: "每周",
        3: "每月",
        9: "无限次",
      },
      searchForm: {
        name: "",
        taskType: "",
        packageName: "",
        lang: "",
        enabled: undefined,
        formal: undefined,
        sortBy: "",
      },
      createDialogVisible: false,
      copyDialogVisible: false,
      editDialogVisible: false,
      copyForm: {
        fromPackageName: "",
        lang: "",
        taskType: "",
        toPackageName: "",
      },
      createForm: {
        name: "",
        taskType: "",
        packageName: "",
        lang: "global",
        promptWords: "",
        icon: "",
        actionText: "",
        adTag: "",
        rewardAmount: 0,
        dayRewardMax: 0,
        cycle: 1,
        limitNum: 0,
        sorted: 0,
        ecpm: 0,
        stayTime: 0,
        enabled: 1,
        formal: true,
        source: "",
        description: "",
        extra: '{"uniqueName":"TEST"}',
      },
      editForm: {
        id: 0,
        name: "",
        taskType: "",
        packageName: "",
        lang: "global",
        promptWords: "",
        icon: "",
        actionText: "",
        adTag: "",
        rewardAmount: 0,
        dayRewardMax: 0,
        cycle: 1,
        limitNum: 0,
        sorted: 0,
        ecpm: 0,
        stayTime: 0,
        enabled: 0,
        formal: true,
        source: "",
        description: "",
        extra: '{"uniqueName":"TEST"}',
      },
    };
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.getTaskList();
    },
    resetSearch() {
      this.searchForm = {
        name: "",
        taskType: "",
        packageName: "",
        lang: "",
        enabled: undefined,
        formal: undefined,
        sortBy: "",
      };
      this.currentPage = 1;
      this.getTaskList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTaskList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTaskList();
    },
    async getTaskList() {
      this.loading = true;
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      if (this.searchForm.name) params.name = this.searchForm.name;
      if (this.searchForm.taskType) params.taskType = this.searchForm.taskType;
      if (this.searchForm.packageName) params.packageName = this.searchForm.packageName;
      if (this.searchForm.lang) params.lang = this.searchForm.lang;
      if (this.searchForm.enabled !== undefined && this.searchForm.enabled !== "") {
        params.enabled = this.searchForm.enabled;
      }
      if (this.searchForm.formal !== undefined && this.searchForm.formal !== "") {
        params.formal = this.searchForm.formal;
      }
      if (this.searchForm.sortBy) params.sortBy = this.searchForm.sortBy;
      const res = await axiosGet("/api/v2/task/list", params);
      this.loading = false;
      if (res.code == 0) {
        this.tableData = res.data.records;
        this.total = res.data.total;
      }
    },
    handleCreate() {
      this.createForm = {
        name: "",
        taskType: "",
        packageName: "",
        lang: "global",
        promptWords: "",
        icon: "",
        actionText: "",
        adTag: "",
        rewardAmount: 0,
        dayRewardMax: 0,
        cycle: 1,
        limitNum: 0,
        sorted: 0,
        ecpm: 0,
        stayTime: 0,
        enabled: 1,
        formal: true,
        source: "",
        description: "",
        extra: '{"uniqueName":"TEST"}',
      };
      this.createDialogVisible = true;
    },
    handleCopyTask() {
      this.copyForm = {
        fromPackageName: "",
        lang: "",
        taskType: "",
        toPackageName: "",
      };
      this.copyDialogVisible = true;
    },
    sureCopyTask() {
      if (!this.copyForm.fromPackageName) {
        this.$message({ message: "任务来源包名为必填项", type: "error" });
        return;
      }
      if (!this.copyForm.toPackageName) {
        this.$message({ message: "目标包名为必填项", type: "error" });
        return;
      }
      axiosPost("/api/v2/task/import", this.copyForm, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "复制成功", type: "success" });
          this.copyDialogVisible = false;
          this.getTaskList();
        }
      });
    },
    handleCancelCopy() {
      this.copyDialogVisible = false;
      this.copyForm = {
        fromPackageName: "",
        lang: "",
        taskType: "",
        toPackageName: "",
      };
    },
    sureCreateTask() {
      if (!this.createForm.name) {
        this.$message({ message: "任务名称为必填项", type: "error" });
        return;
      }
      const params = { ...this.createForm };
      if (params.extra && typeof params.extra === "string") {
        try {
          params.extra = JSON.parse(params.extra);
        } catch (e) {
          this.$message({ message: "Extra字段JSON格式不正确", type: "error" });
          return;
        }
      } else {
        params.extra = {};
      }
      // 过滤空字符串字段和空对象
      Object.keys(params).forEach((key) => {
        const val = params[key];
        if (
          val === "" ||
          (typeof val === "object" && val !== null && Object.keys(val).length === 0)
        ) {
          delete params[key];
        }
      });
      axiosPost("/api/v2/task/add", params, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "创建成功", type: "success" });
          this.createDialogVisible = false;
          this.getTaskList();
        }
      });
    },
    handleEdit(row) {
      let extraStr = "";
      if (row.extra) {
        try {
          const parsed = typeof row.extra === "string" ? JSON.parse(row.extra) : row.extra;
          extraStr = JSON.stringify(parsed, null, 2);
        } catch (e) {
          extraStr = row.extra;
        }
      }
      this.editForm = {
        id: row.id,
        name: row.name || "",
        taskType: row.taskType || "",
        packageName: row.packageName || "",
        lang: row.lang || "global",
        promptWords: row.promptWords || "",
        icon: row.icon || "",
        actionText: row.actionText || "",
        adTag: row.adTag || "",
        rewardAmount: row.rewardAmount || 0,
        dayRewardMax: row.dayRewardMax || 0,
        cycle: row.cycle != null ? row.cycle : 1,
        limitNum: row.limitNum || 0,
        sorted: row.sorted || 0,
        ecpm: row.ecpm || 0,
        stayTime: row.stayTime || 0,
        enabled: row.enabled,
        formal: row.formal,
        source: row.source || "",
        description: row.description || "",
        extra: extraStr,
      };
      this.editDialogVisible = true;
    },
    sureEditTask() {
      if (!this.editForm.id) {
        this.$message({ message: "任务ID缺失", type: "error" });
        return;
      }
      const params = { ...this.editForm };
      if (params.extra && typeof params.extra === "string") {
        try {
          params.extra = JSON.parse(params.extra);
        } catch (e) {
          this.$message({ message: "Extra字段JSON格式不正确", type: "error" });
          return;
        }
      } else {
        params.extra = {};
      }
      // 过滤空字符串字段和空对象
      Object.keys(params).forEach((key) => {
        const val = params[key];
        if (
          val === "" ||
          (typeof val === "object" && val !== null && Object.keys(val).length === 0)
        ) {
          delete params[key];
        }
      });
      axiosPost("/api/v2/task/edit", params, "JSON").then((res) => {
        if (res.code == 0) {
          this.$message({ message: "编辑成功", type: "success" });
          this.editDialogVisible = false;
          this.getTaskList();
        }
      });
    },
  },
  mounted() {
    this.getTaskList();
  },
};
</script>

<style>
.el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  white-space: normal;
}
.el-input-number.el-input-number--mini {
  width: 100%;
}
.el-input-number.el-input-number--mini .el-input-number__decrease,
.el-input-number.el-input-number--mini .el-input-number__increase {
  height: 28px;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/taskManager/taskList.vue